<app-header></app-header>
<div class="app__wrapper">
  <app-main-menu></app-main-menu>
  <div class="app__content">
    <router-outlet></router-outlet>
  </div>
</div>
